import { Component, Input } from '@angular/core';

@Component({
  selector: 'breadcrumbs',
  template: `<ol *ngIf="crumbs && crumbs.length > 0" class="breadcrumb">
  <li *ngFor="let item of crumbs; let isLast = last">

      <a *ngIf="item.state && !isLast" [uiSref]="item.state" [uiParams]="item.params">{{item.label}}</a>
      <span *ngIf="isLast || !item.state">{{item.label}}</span>
  </li>

</ol>`
})
export class BreadcrumbsComponent {
    @Input() crumbs: any[];
}
